(function () {
  var SELECTOR = '.card__swatches--dynamic';
  var INITIALIZED = 'cardSwatchesInit';

  function measureBadge(badge) {
    var wasHidden = badge.hidden;
    badge.hidden = false;
    var width = badge.offsetWidth;
    if (wasHidden) badge.hidden = true;
    return width;
  }

  function outerWidthWithMargins(el) {
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    var ml = parseFloat(style.marginLeft) || 0;
    var mr = parseFloat(style.marginRight) || 0;
    return rect.width + ml + mr;
  }

  function adjust(container) {
    var items = Array.prototype.slice.call(
      container.querySelectorAll(':scope > .opt-label')
    );
    if (!items.length) return;

    var badge = container.querySelector(':scope > .card__swatches-overflow');
    var total = parseInt(container.dataset.swatchCount, 10) || items.length;

    items.forEach(function (el) { el.hidden = false; });
    if (badge) {
      badge.textContent = '+' + total;
      badge.hidden = true;
    }

    var available = container.clientWidth;
    if (!available) return;

    var badgeWidth = badge ? measureBadge(badge) : 0;
    var used = 0;
    var cutoff = items.length;

    for (var i = 0; i < items.length; i++) {
      var w = outerWidthWithMargins(items[i]);
      var remaining = items.length - 1 - i;
      var reserve = remaining > 0 && badge ? badgeWidth : 0;
      if (used + w + reserve > available) {
        cutoff = i;
        break;
      }
      used += w;
    }

    if (cutoff < items.length) {
      for (var j = cutoff; j < items.length; j++) items[j].hidden = true;
      if (badge) {
        badge.textContent = '+' + (items.length - cutoff);
        badge.hidden = false;
      }
    }
  }

  function init(container) {
    if (container.dataset[INITIALIZED]) return;
    container.dataset[INITIALIZED] = 'true';

    adjust(container);

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { adjust(container); });
      ro.observe(container);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SELECTOR)) {
            init(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll(SELECTOR).forEach(init);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (!('ResizeObserver' in window)) {
    window.addEventListener('resize', function () {
      document.querySelectorAll(SELECTOR).forEach(adjust);
    });
  }
})();
